import { createRouter, createWebHistory } from "vue-router";

import { ensureAuthStartup } from "@/auth/startup";
import { empire } from "@/empire";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/pages/LoginPage.vue"),
      meta: { public: true },
    },
    {
      path: "/oauth2/callback",
      name: "oauth-callback",
      component: () => import("@/pages/AuthCallbackPage.vue"),
      meta: { public: true },
    },
    {
      path: "/forbidden",
      name: "forbidden",
      component: () => import("@/pages/ForbiddenPage.vue"),
      meta: { public: true },
    },
    {
      path: "/",
      component: () => import("@/layouts/AdminLayout.vue"),
      children: [
        { path: "leagues", name: "leagues", component: () => import("@/pages/LeaguesPage.vue") },
        {
          path: "leagues/:leagueId",
          name: "league-detail",
          component: () => import("@/pages/LeagueDetailPage.vue"),
        },
        { path: "", name: "dashboard", component: () => import("@/pages/DashboardPage.vue") },
        { path: "account", name: "account", component: () => import("@/pages/AccountPage.vue") },
        {
          path: "applications",
          name: "applications",
          component: () => import("@/pages/ApplicationsPage.vue"),
        },
        {
          path: "applications/:applicationId",
          name: "application-detail",
          component: () => import("@/pages/ApplicationDetailPage.vue"),
        },
        { path: "citizens", name: "citizens", component: () => import("@/pages/CitizensPage.vue") },
        {
          path: "citizens/:citizenId",
          name: "citizen-detail",
          component: () => import("@/pages/CitizenDetailPage.vue"),
        },
        { path: "roles", name: "roles", component: () => import("@/pages/RolesPage.vue") },
        {
          path: "roles/:roleId",
          name: "role-detail",
          component: () => import("@/pages/RoleDetailPage.vue"),
        },
        {
          path: "permissions",
          name: "permissions",
          component: () => import("@/pages/PermissionsPage.vue"),
        },
        { path: "grants", name: "grants", component: () => import("@/pages/GrantsPage.vue") },
        { path: "audit", name: "audit", component: () => import("@/pages/AuditPage.vue") },
      ],
    },
    {
      path: "/:pathMatch(.*)*",
      name: "not-found",
      component: () => import("@/pages/NotFoundPage.vue"),
      meta: { public: true },
    },
  ],
});

router.beforeEach(async (to) => {
  try {
    await ensureAuthStartup();
  } catch {
    return true;
  }

  const isPublic = Boolean(to.meta.public);
  if (!empire.auth.isAuthenticated && !isPublic) {
    return { name: "login", query: { next: to.fullPath } };
  }
  if (empire.auth.isAuthenticated && (to.name === "login" || to.name === "oauth-callback")) {
    return { name: "dashboard" };
  }
  return true;
});
